import { Skeleton } from '@/components/ui/Skeleton';

export function LoginSkeleton() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="bg-card mb-8 w-full max-w-sm rounded-lg border p-6 shadow-sm">
        {/* 标题骨架 */}
        <Skeleton className="mb-4 h-7 w-1/3" />

        <div className="space-y-4">
          {/* 用户名输入框骨架 */}
          <div>
            <Skeleton className="mb-2 h-4 w-16" />
            <Skeleton className="h-10 w-full" />
          </div>

          {/* 密码输入框骨架 */}
          <div>
            <Skeleton className="mb-2 h-4 w-16" />
            <Skeleton className="h-10 w-full" />
          </div>

          {/* 登录按钮骨架 */}
          <Skeleton className="h-10 w-full" />
        </div>
      </div>
    </div>
  );
}
